import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from "react-router-dom";

// Date pickers, localised to the UI language
import './i18n';
import DatePickersProvider from './i18n/DatePickersProvider';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <DatePickersProvider>
        <App />
      </DatePickersProvider>
    </BrowserRouter>
  </React.StrictMode>
);